<template>
  <div>
    <div
        v-if="loading === true"
        class="spinner-grow text-primary"
        style="margin-top: 15%;margin-left: 45%;"
    />
    <div
        v-if="loading === false"
        class="row"
    >
      <div class="col-md-6"/>
      <div class="col-md-6 create-button"/>
    </div>
    <basic-table
        v-if="loading === false"
        :columns="columns"
        :values="rows"
        :selectedPage="tab"
        @choosenObject="getEditedObject($event)" />
<!--        @deleteItems="removeItems($event)"-->
<!--        @deletedMultipleIds="catchIds($event)"-->

    <edit
        v-if="tab === 'general_settings'"
        :settings="editedItem"
        :isLarge="isLarge"
        @refresh="renderTable()"
    />
  </div>
</template>
<script>
import BasicTable from '../../../../shared/tables/BasicTable.vue'
import Edit from './edit.vue'
import generalSettingsService from '@/services/settings/generalSettingsService'

export default {
  components: {
    Edit,
    BasicTable,
  },
  props: ['tab'],
  data() {
    return {
      loading: false,
      choosenTab: '',
      editedItem: '',
      isLarge: true,
      columns: [
        {
          label: 'Parameter',
          field: 'id',
        },
        {
          label: 'Value',
          field: 'value',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getSettings()
  },
  mounted() {
    this.$watch(() => this.tab, val => {
      this.choosenTab = val
    })
  },
  methods: {
    getSettings() {
      this.loading = true
      generalSettingsService.index().then(response => {
        this.loading = false
        this.rows = response.data.data
      })
    },
    getEditedObject(obj) {
      this.isLarge = obj.id === 'PRIVACY' || obj.id === 'TERMS'
      this.editedItem = obj
    },

    renderTable() {
      this.getSettings()
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
